import { fetchApi } from '@/config/axiosSetting';
import { IPatchBodyCostQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCost/patchBodyCostQuery.type';

export const patchBodyCostFunction = (params: IPatchBodyCostQueryParams) => {
  return fetchApi.patch(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/costs/`,
    {
      parts_daghi: Number(
        (params?.data?.parts_daghi ?? '0').toString().replace(/,/g, ''),
      ),
      parts_reduction: Number(
        (params?.data?.parts_reduction ?? '0').toString().replace(/,/g, ''),
      ),
      parts_transportation: Number(
        (params?.data?.parts_transportation ?? '0')
          .toString()
          .replace(/,/g, ''),
      ),
      parts_max_body_price: Number(
        (params?.data?.parts_max_body_price ?? '0')
          .toString()
          .replace(/,/g, ''),
      ),
      vehicle_price: Number(
        (params?.data?.vehicle_price ?? '0').toString().replace(/,/g, ''),
      ),
      parts_prev_reduction: Number(
        (params?.data?.parts_prev_reduction ?? '0')
          .toString()
          .replace(/,/g, ''),
      ),
    },
    {
      params: {
        id: params.id,
      },
    },
  );
};
